module.exports = __webpack_public_path__ + "static/media/productos_naval.1933ec3c.jpg";